




























































































import {
  computed, defineComponent, reactive, ref,
} from '@vue/composition-api';
import { useFormat } from 'vivat';
import { useQuery, useResult } from '@vue/apollo-composable';

import useHighChartMap from '@/useHighChartMap';

import getIncomeSummary from '@/gql/report/analytic/getIncomeSummary.gql';

import Heatmap from '@/components/Map/Heatmap.vue';

const NOW = new Date();

const IncomeByTransfer = defineComponent({
  components: {
    Heatmap,
  },
  setup() {
    const { getProperty } = useHighChartMap();
    const toDate = (date: string) => useFormat.date(date).displayFullThaiDate();
    const getYear = (date: string) => useFormat.date(date).dayjs.get('year');
    const toCurrency = (string: string) => parseFloat(string || '0').toLocaleString('th-TH', { minimumFractionDigits: 0, maximumFractionDigits: 0 });
    const backwardTenYear = Array.from({ length: 10 }, (x, i) => new Date().getFullYear() + 543 - i);
    const selectedYear = ref(new Date().getFullYear() + 543);
    const filter = reactive({
      range: {
        from: useFormat.date(NOW).computerShortDate(),
        to: useFormat.date(NOW).computerShortDate(),
      },
    });
    const computedFilter = computed(() => {
      if (filter.range.from === filter.range.to) return {};
      return {
        range: {
          from: useFormat.date(filter.range.from).computerShortDate(),
          to: useFormat.date(filter.range.to).computerShortDate(),
        },
      };
    });
    const donutTypeFirst = [
      // { display: 'แบ่งตามสาขา (บาท)', name: 'hub' },
      { display: 'แบ่งตามพื้นที่จัดส่ง (บาท)', name: 'area' },
      { display: 'แบ่งตามจังหวัด (บาท)', name: 'province' },
    ];
    const donutTypeSecond = [
      { display: 'แบ่งตามชื่อผู้รับ (บาท)', name: 'customer' },
      { display: 'แบ่งตามลักษณะหีบห่อ (บาท)', name: 'packaging' },
    ];

    const { result: getIncomeSummaryResult } = useQuery(getIncomeSummary, () => ({
      timeframe: computedFilter.value.range,
    }));
    const total = useResult(getIncomeSummaryResult, 0.00, (data) => data.incomeSummary.total);
    const months = useResult(getIncomeSummaryResult, [], (data) => data.incomeSummary.months);
    const hubs = useResult(getIncomeSummaryResult, [], (data) => data.incomeSummary.hubs);
    const areas = useResult(getIncomeSummaryResult, [], (data) => data.incomeSummary.areas);
    const customers = useResult(getIncomeSummaryResult, [], (data) => data.incomeSummary.customers);
    const provinces = useResult(getIncomeSummaryResult, [], (data) => data.incomeSummary.provinces);
    const packageUnits = useResult(getIncomeSummaryResult, [], (data) => data.incomeSummary.packageUnit);

    const thMonthsMini = ['ม.ค.', 'ก.พ.', 'มี.ค.', 'เม.ย.', 'พ.ค.', 'มิ.ย.', 'ก.ค.', 'ส.ค.', 'ก.ย.', 'ต.ค.', 'พ.ย.', 'ธ.ค.'];
    const computedSeriesData = computed(() => months.value.map((val: any) => ({
      x: thMonthsMini[val.monthId - 1],
      y: val.total,
    })));

    const areaCharts = computed(() => ({
      options: {
        dataLabels: { enabled: false },
        yaxis: {
          opposite: false,
          labels: {
            formatter: (val: any) => toCurrency(val),
          },
        },
      },
      series: [
        {
          name: 'รายได้ค่าบริการขนส่ง (บาท)',
          data: computedSeriesData.value,
        },
      ],
    }));

    const colorIndex = ref(0);
    const COLORS = ['pink', 'green', 'blue', 'yellow', 'red', 'gray', 'orange', 'teal', 'indigo', 'purple'];
    function getColor() {
      if (colorIndex.value === 9) colorIndex.value = 0;
      else colorIndex.value += 1;
      return COLORS[colorIndex.value];
    }

    const donutChart = computed(() => {
      let area: any = [];
      if (areas.value.length === 0) area = [];
      else {
        const newAreaArray = areas.value;
        area = newAreaArray
          .map((elm: any) => elm)
          .sort((elm: any, elm2: any) => elm2.total - elm.total);

        const top5 = area.slice(0, 5).map((areaElm: any) => ({
          name: areaElm.areaCode,
          data: areaElm.total,
          color: getColor(),
        }));

        const totalOther = area
          .slice(5)
          .reduce((previousValue: any, currentValue: any) => previousValue + currentValue.total, 0);

        area = [
          ...top5,
          { name: 'อื่น ๆ', data: totalOther, color: getColor() },
        ];
      }

      let customer: any = [];
      if (areas.value.length === 0) customer = [];
      else {
        const newCustomerArray = customers.value;
        customer = newCustomerArray
          .map((elm: any) => elm)
          .sort((elm: any, elm2: any) => elm2.total - elm.total);

        const top5 = customer.slice(0, 5).map((elm: any) => ({
          name: elm.customerName,
          data: elm.total,
          color: getColor(),
        }));

        const totalOther = customer
          .slice(5)
          .reduce((previousValue: any, currentValue: any) => previousValue + currentValue.total, 0);

        customer = [
          ...top5,
          { name: 'อื่น ๆ', data: totalOther, color: getColor() },
        ];
      }

      let hub: any = [];
      if (hubs.value.length === 0) hub = [];
      else {
        const newHubArray = hubs.value;
        hub = newHubArray
          .map((elm: any) => elm)
          .sort((elm: any, elm2: any) => elm2.total - elm.total);

        const top5 = hub.slice(0, 5).map((elm: any) => ({
          name: elm.hubName,
          data: elm.total,
          color: getColor(),
        }));

        const totalOther = hub
          .slice(5)
          .reduce((previousValue: any, currentValue: any) => previousValue + currentValue.total, 0);

        hub = [
          ...top5,
          { name: 'อื่น ๆ', data: totalOther, color: getColor() },
        ];
      }

      let province: any = [];
      if (provinces.value.length === 0) province = [];
      else {
        const newArray = provinces.value;
        province = newArray
          .map((elm: any) => elm)
          .sort((elm: any, elm2: any) => elm2.total - elm.total);

        const top5 = province.slice(0, 5).map((elm: any) => ({
          name: elm.provinceName,
          data: elm.total,
          color: getColor(),
        }));

        const totalOther = province
          .slice(5)
          .reduce((previousValue: any, currentValue: any) => previousValue + currentValue.total, 0);

        province = [
          ...top5,
          { name: 'อื่น ๆ', data: totalOther, color: getColor() },
        ];
      }

      let packaging: any = [];
      if (packageUnits.value.length === 0) packaging = [];
      else {
        const newArray = packageUnits.value;
        packaging = newArray
          .map((elm: any) => elm)
          .sort((elm: any, elm2: any) => elm2.total - elm.total);

        const top5 = packaging.slice(0, 5).map((elm: any) => ({
          name: elm.packageUnit,
          data: elm.total,
          color: getColor(),
        }));

        const totalOther = packaging
          .slice(5)
          .reduce((previousValue: any, currentValue: any) => previousValue + currentValue.total, 0);

        packaging = [
          ...top5,
          { name: 'อื่น ๆ', data: totalOther, color: getColor() },
        ];
      }

      return {
        hub,
        area,
        customer,
        province,
        packaging,
      };
    });

    const computedData = computed(() => {
      const _value: any = {
        northern: [],
        northeastern: [],
        central: [],
        eastern: [],
        western: [],
        southern: [],
      };

      function pushToArray(_region: string, province: string | number, value: number | string) {
        if (_region === 'NORTHERN') _value.northern.push([`th-${province}`, value]);
        else if (_region === 'NORTHEASTERN') _value.northeastern.push([`th-${province}`, value]);
        else if (_region === 'CENTRAL') _value.central.push([`th-${province}`, value]);
        else if (_region === 'EASTERN') _value.eastern.push([`th-${province}`, value]);
        else if (_region === 'WESTERN') _value.western.push([`th-${province}`, value]);
        else if (_region === 'SOUTHERN') _value.southern.push([`th-${province}`, value]);
      }

      const hasValue: number[] = [];
      provinces.value.forEach((elm: any) => {
        hasValue.push(elm.provinceId);
        const { shortForm, region } = getProperty(elm.provinceId);
        pushToArray(region, shortForm, elm.total);
      });
      for (let i = 0; i < 78; i += 1) {
        if (hasValue.indexOf(i) === -1) {
          const { shortForm, region } = getProperty(i);
          pushToArray(region, shortForm, 0);
        }
      }
      return _value;
    });

    return {
      toCurrency,
      toDate,
      getYear,
      filter,

      donutTypeFirst,
      donutTypeSecond,
      areaCharts,
      donutChart,
      backwardTenYear,
      selectedYear,

      computedData,
      computedFilter,
    };
  },
});

export default IncomeByTransfer;
